import configureAxios from 'configure/axios';

const axios = configureAxios();

export const fetchFiltered = (params) => axios.get('insurance/contracts/', { params });
export const find = (id) => axios.get(`insurance/contracts/${id}/`);

export const create = (params) => axios.post('insurance/contracts/', params);
export const activate = (id) => axios.post(`insurance/contracts/${id}/activate/`);

export const cancel = (id) => axios.post(`insurance/contracts/${id}/cancel/`, { expiry_type: 'cancel', force_device_cancellation: true });
